import { useContext } from 'react'

import type { CellContext, RowData } from '@tanstack/react-table'

import { TableCustomizerContext } from '../state/table-customizer'
import { SalesEditableInput } from './input'

interface Props<TData extends RowData, TValue> {
  cellContext: CellContext<TData, TValue>
  format?: (value: string) => string
  className?: string
}

export const TableCellEditor = <TData extends RowData, TValue>({
  cellContext,
  format,
  className,
}: Props<TData, TValue>) => {
  const tableEditorContext = useContext(TableCustomizerContext)
  const cellPath = `${cellContext.row.index}.${cellContext.column.id}`

  const value = cellContext.cell.getValue<string>()

  const onChange = (value: string) => {
    if (!tableEditorContext) {
      return
    }

    tableEditorContext.onCellEdit(cellPath, value)
  }

  const onClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation()
    event.preventDefault()
  }

  return (
    <SalesEditableInput
      onClick={onClick}
      onChange={onChange}
      value={value}
      className={className}
      showInputIf={!!tableEditorContext}
      format={format}
    />
  )
}
